import React from 'react'
import PageHeader from '../components/PageHeader'

const SecondPage = () => (
  <div>
    <PageHeader>About</PageHeader>
    <p>
      This site was built to evoke the feeling of the old{' '}
      <a href="https://en.wikipedia.org/wiki/Dynix_(software)" target="_blank">
        Dynix
      </a>{' '}
      library catalogue software, running on{' '}
      <a
        href="https://terminals-wiki.org/wiki/index.php/Wyse_WY-60"
        taget="_blank"
      >
        Wyse 60
      </a>{' '}
      dumb terminals. If you were at high school in the early 90's in Australia,
      it'll hopefully seem familiar. If you were like me, you used it to find{' '}
      <a href="https://en.wikipedia.org/wiki/Asterix" target="_blank">
        Asterix comics
      </a>{' '}
      and books on{' '}
      <a
        href="http://www.lemon64.com/?mainurl=http%3A//www.lemon64.com/museum/view.php%3Fid%3D302%26genre%3Dmanualmisc"
        target="_blank"
      >
        C64 programming
      </a>
      .
    </p>
    <p>
      I wanted to explore some technologies I hadn't tried before, so this site
      uses{' '}
      <a href="https://www.gatsbyjs.org/docs/adding-images-fonts-files/">
        Gatsby
      </a>, <a href="https://www.styled-components.com">styled-components</a>{' '}
      and CSS variables. It's probably going to look very weird in IE11.
    </p>
  </div>
)

export default SecondPage



// WEBPACK FOOTER //
// ./src/pages/about.js